import { TmdxAvatar, Divider } from '@ds';
import { displayPhoneNumber, getContactFullName, getFullName } from '@/utils/helpers';
import { AssignedOpoContactType, CaseFacility } from '@/api/apis/case';

export const OpoContactTooltip = ({ opoContact, opo }: { opoContact: AssignedOpoContactType; opo: CaseFacility }) => {
  const { firstName, lastName, photoPath, primaryPhone } = opoContact;
  const phone = primaryPhone ?? '';

  return (
    <div className="flex flex-col gap-2 bg-base-60 rounded-xl px-5 py-4">
      <div className="flex gap-4 items-center justify-between">
        <div className="flex items-center">
          <TmdxAvatar
            size="lg"
            radius="lg"
            name={getFullName(firstName, lastName)}
            src={photoPath ?? undefined}
            className="mr-2 w-8 h-8"
          />
          <div className="flex-1 mr-4">
            <div className="text-m-m truncate">{getContactFullName(firstName, lastName)}</div>
            <div className="text-s-r text-base-20 truncate">OPO Contact</div>
          </div>
        </div>
      </div>
      <Divider />
      <div className="text-s-r">
        <div className="flex justify-between gap-4 mb-2">
          <div className="text-base-20">OPO</div>
          <div>{`${opo.code}-${opo.name}`}</div>
        </div>
        <div className="flex justify-between gap-4">
          <div className="text-base-20">Primary Phone</div>
          <div>{displayPhoneNumber(phone)}</div>
        </div>
      </div>
    </div>
  );
};
